<template>
  <v-card outlined class="mx-3 my-3 elevation-0">
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :loading="loading"
      loading-text="Đang Tải"
      mobile-breakpoint="0"
      :items-per-page="5"
      :footer-props="{
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-options': [5, 10, 15, 20],
      }"
      disable-sort
      no-data-text="Không có dữ liệu"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip small label :color="item.status | getAttendanceStatusColor" dark>
          <span>
            {{ item.status | getAttendanceStatus }}
          </span>
        </v-chip>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ convertDate(item.date) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: 'Ngày',
          value: 'date',
          align: 'left',
          sortable: true,
          show: true,
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'center',
          sortable: true,
          show: true,
        },
      ],
    }
  },
  methods: {
    ...mapActions('lessonAttendance', ['fetchAttendances']),
    async fetchData() {
      this.items = []
      this.loading = true
      this.items = await this.fetchAttendances({
        class: this.item.class.id,
        student: this.item.student.id,
        _sort: { date: 1 },
      })
      this.items = this.items.filter((item) => item.status !== 'none').reverse()
      this.loading = false
    },
    convertDate(date) {
      return this.$moment(date).format('DD/MM/YYYY')
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
